import { toast } from 'sonner';

async function request(url: string, options: RequestInit = {}) {
  console.log('[fetch url]', url);
  console.log('[options]', JSON.stringify(options, null, 2));

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || `HTTP error: ${response.status}`);
    }

    return response.json();
  } catch (error: any) {
    if (error?.message !== 'Failed to fetch') {
      toast.error((error as Error)?.message);
    }
    throw error;
  }
}

export default request;
